import React from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash/get";
import CheckoutSettings from "./CheckoutSettings";
import ProductOrderHub from "./ProductOrderHub";
import PresentationSettings from "./PresentationSettings";
import Hub from "./Hub";
import { PRODUCT_COLLECTION_INTENT } from "utils/constants/pricing";
import { STATE_KEYS } from "utils/constants/state";
import { useScrollToElement } from "utils/hooks/editor";

const ProductCollectionBlock = (props) => {
  const name = props.name;
  useScrollToElement(name);
  const { values } = useFormikContext();
  const menuIntent = get(values, STATE_KEYS.EDITOR.MENU_INTENT);
  const showPresentation =
    menuIntent === PRODUCT_COLLECTION_INTENT.PRESENTATION_SETTINGS;
  const showCheckout =
    menuIntent === PRODUCT_COLLECTION_INTENT.CHECKOUT_SETTINGS;
  const showProducts = menuIntent === PRODUCT_COLLECTION_INTENT.PRODUCT_ORDER;

  let content = null;
  const settingsProps = {
    name,
    scrollTop: props.scrollTop
  };

  if (showCheckout) {
    content = <CheckoutSettings {...settingsProps} />;
  } else if (showProducts) {
    content = <ProductOrderHub {...props} />;
  } else if (showPresentation) {
    content = <PresentationSettings {...settingsProps} />;
  } else {
    content = <Hub {...props} />;
  }

  return <div className="w-100 h-100">{content}</div>;
};

ProductCollectionBlock.propTypes = {
  name: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  uid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default ProductCollectionBlock;
